import React, { Component } from 'react';
import Card from 'Utils/Cards/cardGrande';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './OrdenesForm';
import { OrdenUpdateForm } from './OrdenesForm';
import { iconsh } from "icons";

export default class OrdenCrear extends Component {
    state = {
        editar: false,
        mensaje: 'Crear Orden de compra',
        password: false,
    }
    componentWillMount() {
        this.props.uuidInitial();
        if (this.props.match.params.id) {
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Orden de compra'
            });
        }
    }
    guardarBorrador = () => {
        this.state.editar ? this.props.update('as', true) : this.props.create('as', true);
    }
    render() {
        const { create, update } = this.props;
        const { updateData, cargando } = this.props;
        return (
            <div className="container m-0 contenido-principal row d-flex justify-content-center">
                <div className="col-md-12">
                    <Card
                        icono={iconsh.crudOc}
                        titulo={this.state.mensaje}>
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <OrdenUpdateForm
                                        onSubmit={update}
                                        guardarBorrador={this.guardarBorrador}
                                        updateData={updateData}
                                        editando={true} />
                                    :
                                    <Form
                                        me={this.props.me.first_name}
                                        guardarBorrador={this.guardarBorrador}
                                        onSubmit={create} />
                            }
                        </LoadMask>
                    </Card>
                </div>
            </div>
        )
    }
}
